import React from 'react';

import { HeightLayersGuide } from '../../viewer/tools/utils/height-layers';

/**
 * Shows all heights at the snapped point of a tool while the option is on, and stops when it is
 * turned off or the menu or dialog with it is closed.
 */
export const useShowAllHeights = (guide: HeightLayersGuide, enabled: boolean) => {
  React.useEffect(() => {
    guide.enabled = enabled;

    return () => {
      guide.enabled = false;
      guide.hide();
    };
  }, [guide, enabled]);
};
